export default __webpack_public_path__ + "static/media/oma-psv-logo3.7be343e5.svg";